/* Ferdinand Möbius — theme.js */
(function () {
  'use strict';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const moneyFormat = (document.getElementById('drop-data') || {}).dataset ? (document.getElementById('drop-data').dataset.moneyFormat || '') : '';
  const money = (cents) => {
    const v = cents / 100;
    if (moneyFormat.includes('{{')) {
      // Séparateurs selon le format de devise Shopify (amount, _comma_, _space_, _apostrophe_).
      const key = (moneyFormat.match(/\{\{\s*(amount\w*)\s*\}\}/) || [])[1] || 'amount';
      const dec = /no_decimals/.test(key) ? 0 : 2;
      const [thousands, decimal] = /comma_separator/.test(key) ? ['.', ','] : /space_separator/.test(key) ? ['\u202f', ','] : /apostrophe_separator/.test(key) ? ["'", '.'] : [',', '.'];
      const parts = v.toFixed(dec).split('.');
      const n = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (parts[1] ? decimal + parts[1] : '');
      return moneyFormat.replace(/\{\{\s*amount\w*\s*\}\}/, n).replace(/<[^>]+>/g, '');
    }
    return v.toLocaleString('fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  };
  const pad = (n) => String(n).padStart(2, '0');

  /* ---------- Drop : phase + comptes à rebours ---------- */
  const dropEl = $('#drop-data');
  const drop = dropEl ? {
    start: +dropEl.dataset.start, end: +dropEl.dataset.end, next: +dropEl.dataset.next
  } : { start: 0, end: 0, next: 0 };

  function currentPhase() {
    const now = Date.now() / 1000;
    if (drop.start && now < drop.start) return 'upcoming';
    if (drop.end && now < drop.end) return 'live';
    return 'closed';
  }
  let phase = currentPhase();

  function applyPhase(p) {
    $$('[data-drop-root]').forEach((el) => { el.dataset.phase = p; });
    $$('[data-product-form]:not([data-no-drop])').forEach((form) => {
      form.dataset.phase = p;
      const btn = $('[data-add-to-cart]', form);
      if (btn) btn.dispatchEvent(new CustomEvent('phase:refresh'));
    });
    document.dispatchEvent(new CustomEvent('drop:phase', { detail: p }));
  }

  function split(target) {
    let s = Math.max(0, Math.floor(target - Date.now() / 1000));
    const d = Math.floor(s / 86400); s -= d * 86400;
    const h = Math.floor(s / 3600); s -= h * 3600;
    const m = Math.floor(s / 60); s -= m * 60;
    return { d, h, m, s };
  }

  function tick() {
    $$('[data-countdown]').forEach((el) => {
      const t = +el.dataset.countdown;
      if (!t) return;
      const v = split(t);
      const cells = { d: $('[data-cd="d"]', el), h: $('[data-cd="h"]', el), m: $('[data-cd="m"]', el), s: $('[data-cd="s"]', el) };
      if (cells.d) cells.d.textContent = pad(v.d);
      if (cells.h) cells.h.textContent = pad(v.h);
      if (cells.m) cells.m.textContent = pad(v.m);
      if (cells.s) cells.s.textContent = pad(v.s);
      el.classList.toggle('is-over', t <= Date.now() / 1000);
    });
    $$('[data-countdown-inline]').forEach((el) => {
      const t = +el.dataset.countdownInline;
      if (!t) { el.textContent = '…'; return; }
      const v = split(t);
      el.textContent = v.d > 0 ? `${v.d} j ${v.h} h ${pad(v.m)} min` : `${v.h} h ${pad(v.m)} min ${pad(v.s)} s`;
    });
    const p = currentPhase();
    if (p !== phase) { phase = p; applyPhase(p); }
  }
  applyPhase(phase);
  tick();
  setInterval(tick, 1000);

  /* ---------- Menu mobile ---------- */
  const mmenu = $('#mobile-menu');
  $$('[data-menu-open]').forEach((b) => b.addEventListener('click', () => { mmenu.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }));
  $$('[data-menu-close]').forEach((b) => b.addEventListener('click', closeMenu));
  function closeMenu() { if (mmenu) { mmenu.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } }

  /* ---------- Tiroir panier ---------- */
  const drawer = $('#cart-drawer');
  let lastFocus = null;
  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => $('.drawer__panel', drawer).focus(), 50);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); }));
  $$('[data-drawer-close]').forEach((b) => b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); closeMenu(); } });

  /* ---------- Toast ---------- */
  let toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(() => toastEl.classList.remove('is-on'), 2600);
  }

  /* ---------- Panier AJAX ---------- */
  const cartApi = {
    get: () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()),
    add: (body) => fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(async (r) => { const j = await r.json(); if (!r.ok) throw j; return j; }),
    change: (key, quantity) => fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) }).then((r) => r.json())
  };

  function renderItem(item) {
    const props = Object.entries(item.properties || {}).filter(([k, v]) => !k.startsWith('_') && v).map(([k, v]) => `<p class="citem__var">${esc(k)} : ${esc(v)}</p>`).join('');
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="citem__var">${esc(item.variant_title)}</p>` : '';
    const img = item.image ? `<img src="${item.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2')}" width="120" height="150" alt="" loading="lazy">` : '';
    return `<div class="citem" data-cart-item data-key="${item.key}">
      <a class="citem__media" href="${item.url}">${img}</a>
      <div class="citem__body">
        <p class="citem__title">${esc(item.product_title)}</p>${variant}${props}
        <div class="citem__row">
          <div class="qty">
            <button type="button" class="qty__btn" data-qty-change="-1" aria-label="Retirer un"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 12h14"/></svg></button>
            <input class="qty__input" type="number" min="0" value="${item.quantity}" data-qty-input aria-label="Quantité">
            <button type="button" class="qty__btn" data-qty-change="1" aria-label="Ajouter un"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 5v14M5 12h14"/></svg></button>
          </div>
          <span class="citem__price">${money(item.final_line_price)}</span>
        </div>
      </div>
      <button type="button" class="citem__remove" data-remove aria-label="Retirer"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6l12 12M18 6 6 18"/></svg></button>
    </div>`;
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }

  function renderCart(cart) {
    $$('[data-cart-items]').forEach((wrap) => {
      const empty = $('[data-cart-empty]', wrap);
      $$('[data-cart-item]', wrap).forEach((n) => n.remove());
      const html = cart.items.map(renderItem).join('');
      if (empty) { empty.insertAdjacentHTML('beforebegin', html); empty.hidden = cart.item_count > 0; }
      else wrap.insertAdjacentHTML('afterbegin', html);
    });
    $$('[data-cart-total]').forEach((n) => { n.textContent = money(cart.total_price); });
    $$('[data-cart-count]').forEach((n) => { n.textContent = cart.item_count; n.dataset.count = cart.item_count; n.classList.add('is-bump'); setTimeout(() => n.classList.remove('is-bump'), 250); });
    $$('[data-cart-count-inline]').forEach((n) => { n.textContent = `(${cart.item_count})`; });
    $$('[data-checkout]').forEach((b) => { b.disabled = cart.item_count === 0; });
    document.dispatchEvent(new CustomEvent('cart:update', { detail: cart }));
  }
  $$('[data-cart-count]').forEach((n) => { n.dataset.count = n.textContent.trim(); });

  document.addEventListener('click', async (e) => {
    const chg = e.target.closest('[data-qty-change]');
    const rm = e.target.closest('[data-remove]');
    const quick = e.target.closest('[data-quick-add]');
    if (chg) {
      const item = chg.closest('[data-cart-item]');
      const input = $('[data-qty-input]', chg.parentElement);
      const q = Math.max(item ? 0 : 1, (+input.value || 0) + (+chg.dataset.qtyChange));
      input.value = q;
      if (item) updateLine(item, q);
    }
    if (rm) { const item = rm.closest('[data-cart-item]'); if (item) updateLine(item, 0); }
    if (quick) {
      if (phase !== 'live' && !quick.hasAttribute('data-no-drop')) { toast('Les précommandes ne sont pas ouvertes.'); return; }
      quick.classList.add('is-loading');
      try {
        const props = quick.hasAttribute('data-no-drop') ? {} : { Drop: dropEl ? dropEl.dataset.name : '', _precommande: 'oui' };
        await cartApi.add({ items: [{ id: +quick.dataset.quickAdd, quantity: 1, properties: props }] });
        renderCart(await cartApi.get()); openDrawer();
      } catch (err) { toast(err && err.description ? err.description : 'Ajout impossible.'); }
      quick.classList.remove('is-loading');
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-item] [data-qty-input]');
    if (input) updateLine(input.closest('[data-cart-item]'), Math.max(0, +input.value || 0));
  });
  async function updateLine(item, q) {
    item.classList.add('is-busy');
    try { renderCart(await cartApi.change(item.dataset.key, q)); } catch (_) { toast('Mise à jour impossible.'); item.classList.remove('is-busy'); }
  }

  /* ---------- Formulaire produit : variantes + ajout ---------- */
  $$('[data-product-form]').forEach((root) => {
    const form = $('form', root);
    const variants = JSON.parse($('[data-variants]', root).textContent);
    const idInput = $('[data-variant-id]', root);
    const btn = $('[data-add-to-cart]', root);
    const label = $('[data-btn-label]', root);
    const err = $('[data-form-error]', root);
    let current = variants.find((v) => String(v.id) === idInput.value) || variants[0];

    const optionSets = () => $$('fieldset.opt', root).filter((fs) => $('[data-option-input]', fs));
    function selectedOptions() { return optionSets().map((fs) => { const c = $('[data-option-input]:checked', fs); return c ? c.value : null; }); }
    function refreshButton() {
      const p = root.dataset.phase;
      if (!current) { btn.disabled = true; label.textContent = 'Indisponible'; return; }
      if (p === 'shop') { btn.disabled = !current.available; label.textContent = current.available ? 'Ajouter au panier' : 'Épuisé'; }
      else if (p === 'live') { btn.disabled = !current.available; label.textContent = current.available ? 'Précommander' : 'Épuisé pour ce drop'; }
      else if (p === 'upcoming') { btn.disabled = true; label.textContent = 'Ouverture bientôt'; }
      else { btn.disabled = true; label.textContent = 'Drop clos'; }
    }
    function refreshVariant() {
      const opts = selectedOptions();
      current = variants.find((v) => v.options.every((o, i) => o === opts[i]));
      if (current) {
        idInput.value = current.id;
        const priceRoot = root.closest('.prod') || document;
        const price = $('.prod__price .price__now', priceRoot) || $('.price__now', priceRoot); if (price) price.textContent = money(current.price);
        const was = $('.prod__price .price__was', priceRoot); if (was) { was.hidden = !(current.compare_at_price > current.price); if (current.compare_at_price) was.textContent = money(current.compare_at_price); }
        const url = new URL(location.href); url.searchParams.set('variant', current.id); history.replaceState({}, '', url);
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { featured_media: current.featured_media, priceText: money(current.price) } }));
      }
      optionSets().forEach((fs, i) => {
        const val = $('[data-opt-value]', fs) || $('legend span', fs); const c = $('[data-option-input]:checked', fs); if (val && c) val.textContent = c.value;
        $$('[data-option-input]', fs).forEach((inp) => {
          const test = opts.slice(); test[i] = inp.value;
          const match = variants.find((v) => v.options.every((o, j) => j > i ? true : o === test[j]));
          const lab = inp.nextElementSibling;
          if (lab && lab.tagName === 'LABEL') lab.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
      refreshButton();
    }
    root.addEventListener('change', (e) => { if (e.target.matches('[data-option-input]')) refreshVariant(); });
    root.addEventListener('cfg:refresh', refreshVariant);
    btn.addEventListener('phase:refresh', refreshButton);
    refreshVariant();

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (btn.disabled) return;
      err.hidden = true; btn.classList.add('is-loading');
      const fd = new FormData(form);
      const properties = {};
      fd.forEach((v, k) => { const m = k.match(/^properties\[(.+)\]$/); if (m && String(v).trim() !== '') properties[m[1]] = v; });
      try {
        await cartApi.add({ items: [{ id: +fd.get('id'), quantity: +fd.get('quantity') || 1, properties }] });
        renderCart(await cartApi.get()); openDrawer();
      } catch (ex) { err.textContent = ex && ex.description ? ex.description : 'Ajout impossible. Réessayez.'; err.hidden = false; }
      btn.classList.remove('is-loading');
    });
  });

  /* ---------- Divers ---------- */
  $$('[data-recover-open]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); const r = $('#recover'); if (r) { r.hidden = false; $('input', r).focus(); } }));
  $$('select[data-default]').forEach((s) => { const v = s.dataset.default; if (v) Array.from(s.options).forEach((o) => { if (o.value === v) o.selected = true; }); });
  if (location.hash === '#recover') { const r = $('#recover'); if (r) r.hidden = false; }
})();

/* ===== Profondeur : animations et interactions ===== */
(function () {
  'use strict';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Apparition au défilement */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    $$('.reveal').forEach((el) => io.observe(el));
    $$('.grid').forEach((g) => $$('.card', g).forEach((c, i) => c.style.setProperty('--i', i % 6)));
  } else { $$('.reveal').forEach((el) => el.classList.add('is-in')); }

  /* En-tête : s'efface en descendant, revient en montant */
  const hdr = $('[data-header]');
  let lastY = window.scrollY;
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    if (hdr) hdr.classList.toggle('is-hidden', y > 120 && y > lastY);
    lastY = y;
  }, { passive: true });

  /* Héro : parallaxe douce */
  const par = $('[data-parallax] .hero__img');
  if (par && !reduce) {
    const move = () => { const y = Math.min(window.scrollY, 900); par.style.transform = `scale(1.06) translateY(${y * 0.12}px)`; };
    window.addEventListener('scroll', move, { passive: true }); move();
  }

  /* Compte à rebours : tic sur changement */
  if (!reduce) {
    const obs = new MutationObserver((muts) => muts.forEach((m) => {
      const el = m.target.parentElement && m.target.parentElement.closest ? m.target.parentElement.closest('.countdown__num') : null;
      const n = el || (m.target.nodeType === 1 ? m.target : null);
      if (n && n.classList && n.classList.contains('countdown__num')) { n.classList.remove('is-tick'); void n.offsetWidth; n.classList.add('is-tick'); }
    }));
    $$('.countdown__num').forEach((n) => obs.observe(n, { childList: true, characterData: true, subtree: true }));
  }

  /* Compteur animé */
  $$('[data-counter]').forEach((el) => {
    const target = parseInt(String(el.dataset.counter).replace(/\D/g, ''), 10) || 0;
    const run = () => { const t0 = performance.now(); const d = 1400; const step = (t) => { const p = Math.min(1, (t - t0) / d); const e = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(target * e).toLocaleString('fr-FR'); if (p < 1) requestAnimationFrame(step); }; requestAnimationFrame(step); };
    if (reduce) { el.textContent = target.toLocaleString('fr-FR'); return; }
    const io = new IntersectionObserver((en) => { if (en[0].isIntersecting) { run(); io.disconnect(); } }, { threshold: 0.5 }); io.observe(el);
  });

  /* Récit en chapitres */
  $$('[data-story]').forEach((story) => {
    const chaps = $$('[data-story-chap]', story); const imgs = $$('[data-story-img]', story);
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { const i = e.target.dataset.storyChap; chaps.forEach((c) => c.classList.toggle('is-on', c.dataset.storyChap === i)); imgs.forEach((im) => im.classList.toggle('is-on', im.dataset.storyImg === i)); } });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    chaps.forEach((c) => io.observe(c));
  });

  /* Finitions */
  $$('[data-finishes]').forEach((root) => {
    root.addEventListener('click', (e) => {
      const tab = e.target.closest('[data-fin-tab]'); if (!tab) return;
      const i = tab.dataset.finTab;
      $$('[data-fin-tab]', root).forEach((t) => { const on = t.dataset.finTab === i; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on); });
      $$('[data-fin-img]', root).forEach((im) => im.classList.toggle('is-on', im.dataset.finImg === i));
      $$('[data-fin-panel]', root).forEach((p) => p.classList.toggle('is-on', p.dataset.finPanel === i));
    });
  });

  /* Galerie : glisser à la souris */
  $$('[data-gallery-scroll]').forEach((row) => {
    let down = false, sx = 0, sl = 0;
    row.addEventListener('pointerdown', (e) => { down = true; sx = e.clientX; sl = row.scrollLeft; row.style.scrollSnapType = 'none'; });
    window.addEventListener('pointerup', () => { down = false; row.style.scrollSnapType = ''; });
    row.addEventListener('pointermove', (e) => { if (down) row.scrollLeft = sl - (e.clientX - sx); });
  });

  /* Fiche pièce : visionneuse, vignettes, zoom, variante → image */
  $$('[data-gallery]').forEach((gal) => {
    const medias = $$('.prod__media', gal); const thumbs = $$('[data-thumb]', gal);
    let idx = Math.max(0, medias.findIndex((m) => m.classList.contains('is-on')));
    const show = (i) => {
      idx = (i + medias.length) % medias.length;
      medias.forEach((m, k) => { m.classList.toggle('is-on', k === idx); m.classList.remove('is-zoom'); });
      thumbs.forEach((t) => t.classList.toggle('is-on', t.dataset.thumb === medias[idx].dataset.mediaId));
      const th = thumbs[idx]; if (th && th.scrollIntoView) th.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };
    thumbs.forEach((t) => t.addEventListener('click', () => show(medias.findIndex((m) => m.dataset.mediaId === t.dataset.thumb))));
    const prev = $('[data-viewer-prev]', gal), next = $('[data-viewer-next]', gal);
    if (prev) prev.addEventListener('click', () => show(idx - 1));
    if (next) next.addEventListener('click', () => show(idx + 1));
    let tx = 0;
    gal.addEventListener('touchstart', (e) => { tx = e.touches[0].clientX; }, { passive: true });
    gal.addEventListener('touchend', (e) => { const dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 50) show(dx < 0 ? idx + 1 : idx - 1); });
    medias.forEach((m) => {
      const img = $('img', m); if (!img) return;
      m.addEventListener('click', () => { if (window.innerWidth <= 900) return; m.classList.toggle('is-zoom'); });
      m.addEventListener('mousemove', (e) => { if (!m.classList.contains('is-zoom')) return; const r = m.getBoundingClientRect(); img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`; });
      m.addEventListener('mouseleave', () => m.classList.remove('is-zoom'));
    });
    document.addEventListener('variant:change', (e) => {
      const fm = e.detail && e.detail.featured_media; if (!fm) return;
      const i = medias.findIndex((m) => String(m.dataset.mediaId) === String(fm.id)); if (i >= 0) show(i);
    });
  });

  /* Gravure : aperçu */
  $$('[data-grav-input]').forEach((inp) => {
    const root = inp.closest('.grav'); const cnt = $('[data-grav-count]', root); const prev = $('[data-grav-preview]', root);
    const up = () => { cnt.textContent = inp.value.length; prev.textContent = inp.value; };
    inp.addEventListener('input', up); up();
  });

  /* Barre d'achat mobile */
  const bar = $('[data-stickybar]'); const form = $('[data-product-form] form');
  if (bar && form) {
    const btn = $('[data-add-to-cart]', form);
    const io = new IntersectionObserver((en) => bar.classList.toggle('is-on', !en[0].isIntersecting), { threshold: 0 });
    io.observe(btn);
    $('[data-sticky-buy]', bar).addEventListener('click', () => { if (btn.disabled) { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; } btn.click(); });
    document.addEventListener('variant:change', (e) => { const p = $('[data-sticky-price]', bar); if (p && e.detail && e.detail.priceText) p.textContent = e.detail.priceText; });
  }

  /* Tiroir : livraison offerte */
  const ship = $('[data-ship]');
  if (ship) {
    const th = +ship.dataset.threshold; const txt = $('[data-ship-text]', ship); const fill = $('[data-ship-fill]', ship);
    const fmt = (c) => (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
    const update = (total) => { const r = th - total; fill.style.width = Math.min(100, (total / th) * 100) + '%'; txt.textContent = r > 0 ? `Plus que ${fmt(r)} pour la livraison offerte.` : 'Livraison offerte.'; };
    document.addEventListener('cart:update', (e) => update(e.detail.total_price));
    fetch('/cart.js').then((r) => r.json()).then((c) => update(c.total_price)).catch(() => {});
  }
  document.addEventListener('cart:update', () => document.body.classList.add('drawer-open'));

  /* Suggestions du panier : masquer ce qui est déjà au panier, armer le code de remise */
  const suggRoots = $$('[data-suggestions]');
  if (suggRoots.length) {
    const syncSugg = (cart) => {
      const inCart = new Set((cart.items || []).map((i) => i.product_id));
      suggRoots.forEach((root) => {
        const max = +root.dataset.max || 3;
        let shown = 0;
        $$('[data-sugg-item]', root).forEach((it) => {
          const already = inCart.has(+it.dataset.productId);
          const show = !already && shown < max;
          it.hidden = !show;
          if (show) shown += 1;
        });
        root.hidden = shown === 0;
      });
    };
    document.addEventListener('cart:update', (e) => syncSugg(e.detail));
    fetch('/cart.js').then((r) => r.json()).then(syncSugg).catch(() => {});

    let armed = false;
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-sugg-add]');
      if (!b || armed) return;
      const root = b.closest('[data-suggestions]');
      const code = root && root.dataset.code;
      if (!code) return;
      armed = true;
      fetch('/discount/' + encodeURIComponent(code), { method: 'GET' }).catch(() => {});
    }, true);
  }
  $$('[data-drawer-close]').forEach((b) => b.addEventListener('click', () => document.body.classList.remove('drawer-open')));
})();

/* ===== Fiche modèle agrandie ===== */
(function () {
  'use strict';
  const root = document.querySelector('[data-models]');
  const modal = document.getElementById('model-view');
  if (!root || !modal) return;
  const content = modal.querySelector('[data-model-content]');
  const panel = modal.querySelector('.mv__panel');
  const ids = Array.from(root.querySelectorAll('[data-model-data]')).map((t) => t.dataset.modelData);
  let cur = null, lastFocus = null;

  function render(id) {
    const tpl = root.querySelector(`[data-model-data="${id}"]`);
    if (!tpl) return;
    content.innerHTML = '';
    content.appendChild(tpl.content.cloneNode(true));
    const phase = (document.querySelector('[data-models]') || {}).dataset ? root.dataset.phase : 'live';
    content.querySelectorAll('.mv__note').forEach((n) => { n.setAttribute('data-drop-root', ''); n.dataset.phase = phase; });
    cur = id;
  }
  function open(id) {
    lastFocus = document.activeElement;
    render(id);
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => panel.focus(), 40);
  }
  function close() {
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    content.innerHTML = '';
    if (lastFocus) lastFocus.focus();
  }
  function step(d) {
    const i = ids.indexOf(cur);
    if (i < 0) return;
    render(ids[(i + d + ids.length) % ids.length]);
    const m = modal.querySelector('.mv__media'); if (m) m.scrollTop = 0;
    const info = modal.querySelector('.mv__info'); if (info) info.scrollTop = 0;
  }
  root.addEventListener('click', (e) => {
    const b = e.target.closest('[data-model-open]');
    if (b) { e.preventDefault(); open(b.dataset.modelOpen); }
  });
  modal.querySelectorAll('[data-model-close]').forEach((b) => b.addEventListener('click', close));
  const prev = modal.querySelector('[data-model-prev]'), next = modal.querySelector('[data-model-next]');
  if (prev) prev.addEventListener('click', () => step(-1));
  if (next) next.addEventListener('click', () => step(1));
  document.addEventListener('keydown', (e) => {
    if (modal.getAttribute('aria-hidden') === 'true') return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowRight') step(1);
    if (e.key === 'ArrowLeft') step(-1);
  });
})();

/* ===== Configurateur : couleurs de cordon, récapitulatif ===== */
(function () {
  'use strict';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  $$('.cfg').forEach((cfg) => {
    const cordonName = cfg.dataset.cordonOption || 'Cordon';
    const cordonStep = $('[data-cordon-step]', cfg);
    const colorStep = $('[data-color-step]', cfg);
    const groups = $$('[data-color-group]', cfg);
    const colorEmpty = $('[data-color-empty]', cfg);
    const recap = $('[data-cfg-recap]', cfg);

    function selectedCordon() {
      if (!cordonStep) return null;
      const c = $('input:checked', cordonStep);
      return c ? c.value : null;
    }
    function syncColors() {
      if (!colorStep) return;
      const val = selectedCordon();
      let shown = null;
      groups.forEach((g) => {
        const on = !val || g.dataset.colorGroup === val;
        g.hidden = !on;
        $$('input', g).forEach((i) => { i.disabled = !on; });
        if (on) shown = g;
      });
      if (shown && !$('input:checked', shown)) { const f = $('input', shown); if (f) f.checked = true; }
      const has = !!shown;
      colorStep.hidden = false;
      if (colorEmpty) colorEmpty.hidden = has;
      const lbl = $('[data-color-value]', cfg);
      const chk = shown ? $('input:checked', shown) : null;
      if (lbl) lbl.textContent = chk ? chk.value : '';
      if (!has && colorStep) colorStep.hidden = true;
    }
    function syncLabels() {
      const size = $('[data-size-input]:checked', cfg);
      const sl = $('[data-size-value]', cfg);
      if (sl && size) sl.textContent = size.value;
      $$('.cfg__step', cfg).forEach((st) => {
        const any = $('input:checked:not([disabled])', st);
        st.classList.toggle('is-set', !!any || (st.classList.contains('grav') && $('[data-grav-input]', st) && $('[data-grav-input]', st).value.length > 0));
      });
    }
    function buildRecap() {
      if (!recap) return;
      const rows = [];
      $$('fieldset.opt', cfg).forEach((fs) => {
        if (!$('[data-option-input]', fs)) return;
        const legend = $('legend', fs);
        let name = '';
        if (legend) legend.childNodes.forEach((n) => { if (n.nodeType === 3 && n.textContent.trim()) name = n.textContent.trim(); });
        const c = $('[data-option-input]:checked', fs);
        if (name && c) rows.push([name, c.value]);
      });
      const col = $('[data-color-input]:checked:not([disabled])', cfg);
      if (col) rows.push(['Couleur du cordon', col.value]);
      const size = $('[data-size-input]:checked', cfg);
      if (size) rows.push(['Tour de poignet', size.value]);
      const grav = $('[data-grav-input]', cfg);
      if (grav && grav.value) rows.push(['Gravure', grav.value]);
      recap.innerHTML = rows.map(([k, v]) => `<li><span>${k}</span><strong>${v.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]))}</strong></li>`).join('');
    }
    function sync() { syncColors(); syncLabels(); buildRecap(); }

    cfg.addEventListener('change', sync);
    cfg.addEventListener('input', (e) => { if (e.target.matches('[data-grav-input]')) { syncLabels(); buildRecap(); } });
    document.addEventListener('variant:change', (e) => {
      const p = $('.cfg__price .price__now', cfg);
      if (p && e.detail && e.detail.priceText) p.textContent = e.detail.priceText;
      buildRecap();
    });
    sync();
  });
})();


/* ===== Recommandations produit ===== */
(function () {
  'use strict';
  const mount = document.querySelector('[data-reco]');
  if (!mount || !mount.dataset.url) return;
  fetch(mount.dataset.url)
    .then((r) => (r.ok ? r.text() : Promise.reject()))
    .then((html) => {
      const el = document.createElement('div');
      el.innerHTML = html;
      const sec = el.querySelector('.reco');
      if (sec) {
        mount.innerHTML = '';
        mount.appendChild(sec);
        sec.querySelectorAll('.reveal').forEach((n) => n.classList.add('is-in'));
      }
    })
    .catch(() => {});
})();

/* ===== Histoire : fondu enchaîné au défilement ===== */
(function () {
  'use strict';
  const root = document.querySelector('[data-story-scroll]');
  if (!root || !('IntersectionObserver' in window)) {
    if (root) root.querySelectorAll('.ss__chap').forEach((c) => c.classList.add('is-on'));
    return;
  }
  const chaps = Array.from(root.querySelectorAll('[data-ss-chap]'));
  const layers = Array.from(root.querySelectorAll('[data-ss-layer]'));
  const caps = Array.from(root.querySelectorAll('[data-ss-caption]'));
  let current = null;

  const show = (i) => {
    if (i === current) return;
    current = i;
    layers.forEach((l) => l.classList.toggle('is-on', l.dataset.ssLayer === i));
    caps.forEach((c) => c.classList.toggle('is-on', c.dataset.ssCaption === i));
  };

  const visible = new Set();
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      const i = e.target.dataset.ssChap;
      e.target.classList.toggle('is-on', e.isIntersecting);
      if (e.isIntersecting) visible.add(i); else visible.delete(i);
    });
    if (visible.size) show(Array.from(visible).sort((a, b) => a - b)[0]);
  }, { rootMargin: '-35% 0px -35% 0px', threshold: 0 });
  chaps.forEach((c) => io.observe(c));

  const intro = root.querySelector('.ss__intro');
  if (intro) {
    new IntersectionObserver((en) => { if (en[0].isIntersecting) show('1'); }, { threshold: 0.4 }).observe(intro);
  }
})();
